export class Favorite {
    constructor(locationDetail) {
        this.locationDetail = locationDetail;
        this.id = '';
        this.findLinks().forEach(link => {
            const id = link.dataset.id;

            if(this.isActive(id)) {
                this.markLinkAsActive(link);
            }

            link.addEventListener('click', () => this.toggle(id));
        });
    }

    getClassName(modifier) {
        if (modifier) return this.locationDetail.getClassName('activation-link--' + modifier);
        return this.locationDetail.getClassName('activation-link');
    }

    findLinks() {
        return this.locationDetail.find('activation-link');
    }

    dispatchEvent(id, active) {
        const event = new Event('FavoriteChanged');
        event.data = {id, active};
        window.dispatchEvent(event);
    }

    markLinkAsActive(link) {
        link.classList.add(
            this.getClassName('active')
        );
    }

    activate(id) {
        localStorage.setItem('efs-location', id);
        this.findLinks().forEach(el => {
            if (el.dataset.id === id) {
                if(el.dataset.city) {
                    localStorage.setItem('efs-myMarket', el.dataset.city);
                }
                el.classList.add(
                    this.getClassName('active')
                );
            } else {
                el.classList.remove(
                    this.getClassName('active')
                );
            }
        });
        this.dispatchEvent(id, true)
    }

    deactivate(id) {
        localStorage.removeItem('efs-location');
        this.findLinks().forEach(el => {
            if (el.dataset.id === id) {
                if(el.dataset.city) {
                    localStorage.setItem('efs-myMarket', "Mein Lieblingsmarkt");
                }
                el.classList.remove(this.getClassName('active'));
            }
        });
        this.dispatchEvent(id, false)
    }

    isActive(id) {
        return localStorage.getItem('efs-location') === id;
    }

    toggle(id) {
        if (this.isActive(id)) return this.deactivate(id);
        return this.activate(id);
    }
}
